import { Fragment, useMemo } from 'react';
import { useEffectOnce } from 'react-use';
import { PanelControls } from '~/components/ui/PanelControls';
import { rage, useInputAction, useObservable } from '~/rage';
import { InputAction, InputKey, WalletType } from '~/shared';
import { useBuy } from '../../hooks';
import {
	setActiveIndex,
	setActiveIndexNext,
	setActiveIndexPrev,
	setActiveStage,
	setMaxIndex,
	TuningStudioStage,
	useLayoutDispatch,
	useLayoutSelector,
} from '../../redux';
import { Categories } from '../Categories';
import { colorSelectItems } from '../ColorSelect/ColorSelect.model';
import { MenuItem } from '../MenuItem';
import { StyledBottomContainer, StyledControlsContainer } from './Paint.styled';

const Paint = () => {
	const dispatch = useLayoutDispatch();
	const activeIndex = useLayoutSelector(
		(state) => state.tuningStudio.activeIndex,
	);
	const modalState = useObservable(rage.modal.getCurrentModal());
	const interfaceHidden = useLayoutSelector(
		(state) => state.tuningStudio.interfaceHidden,
	);
	const { handleBuy } = useBuy();

	const handleBack = () => {
		dispatch(setActiveIndex(0));
		dispatch(setActiveStage(TuningStudioStage.MAIN));
	};

	const leftControls = useMemo(
		() => [
			{
				text: 'Управление',
				keys: [InputKey.ArrowLeft, InputKey.ArrowRight],
			},
			{
				text: 'Купить',
				keys: [InputKey.Enter],
				onClick: () => handleBuy(WalletType.Cash),
			},
			{
				text: 'Крутить камеру',
				keys: [InputKey.MouseRight],
			},
		],
		[handleBuy],
	);

	const rightControls = [
		{
			text: 'Выйти',
			keys: ['Esc'],
			onClick: () => rage.vehicleTuningShop.exitMenu(),
		},
	];

	useInputAction(InputAction.CommonMenuNavLeft, () => {
		if (modalState || interfaceHidden) {
			return;
		}
		dispatch(setActiveIndexPrev());
	});

	useInputAction(InputAction.CommonMenuNavRight, () => {
		if (modalState || interfaceHidden) {
			return;
		}
		dispatch(setActiveIndexNext());
	});

	useInputAction(InputAction.CommonMenuClose, () => {
		if (modalState || interfaceHidden) {
			return;
		}
		handleBack();
	});

	useInputAction(InputAction.CommonMenuAccept, () => {
		if (modalState || interfaceHidden) {
			return;
		}
		handleBuy(WalletType.Cash);
	});

	useEffectOnce(() => {
		dispatch(setActiveIndex(0));
		dispatch(setMaxIndex(colorSelectItems.length - 1));

		return () => {
			dispatch(setActiveIndex(0));
		};
	});

	return (
		<Fragment>
			<StyledBottomContainer>
				<Categories
					name="Покрасочная"
					activeIndex={activeIndex}
					totalCount={colorSelectItems.length}
					handleBack={handleBack}
					handlePrev={() => dispatch(setActiveIndexPrev())}
					handleNext={() => dispatch(setActiveIndexNext())}
				>
					{colorSelectItems.map((item, index) => (
						<MenuItem
							type="menu"
							name={item.name}
							icon={item.icon}
							active={activeIndex === index}
							onClick={() => dispatch(setActiveIndex(index))}
							key={index}
							id={`paintItem#${index}`}
						/>
					))}
				</Categories>
			</StyledBottomContainer>
			<StyledControlsContainer>
				<PanelControls controls={leftControls} align="left" />
				<PanelControls controls={rightControls} align="right" />
			</StyledControlsContainer>
		</Fragment>
	);
};

export { Paint };
